(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-process-images-carousel-section"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", (event) => {
  const swiper = new Swiper('.our-process-image-carousel-obj', {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.25,
    spaceBetween: 15,
    grabCursor: true,
    pauseOnMouseEnter: true,
    autoplay: {
       delay: 3500
     },
    breakpoints: {
      768: {
        slidesPerView: 1.35,
        spaceBetween: 20
      },
      1400: {
        slidesPerView: 1.45,
        spaceBetween: 30
      }
    },
    navigation: {
      nextEl: '.our-process-image-carousel-obj .swiper-button-next',
      prevEl: '.our-process-image-carousel-obj .swiper-button-prev',
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-process-testimonials-section"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", (event) => {
  const swiper = new Swiper('.our-process-testimonials-carousel-obj', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    grabCursor: true,
    pauseOnMouseEnter: true,
    autoplay: {
       delay: 8000
     },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 40
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 60
      }
    },
    navigation: {
      nextEl: '.our-process-testimonials-carousel-obj .swiper-button-next',
      prevEl: '.our-process-testimonials-carousel-obj .swiper-button-prev',
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
